module.exports = __webpack_public_path__ + "img/vip.a41d851d.png";